export default "__VITE_ASSET__Cz$QaC7G__"